import React from 'react';
import { Flex, Box } from 'rebass';

const GraduateBadges = ({ badgeKeys, boolFilters }) => (
  <Flex mx={-1}>
    {Object.keys(badgeKeys)
      .filter(key => badgeKeys[key])
      .map((key, idx) => (
        <Box p={1} key={`badge-${idx}`}>
          {boolFilters.find(filter => filter.key === `data.${key}`)?.indicator}
        </Box>
      ))}
  </Flex>
);

export default GraduateBadges;
